define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');

  return IpsModel.extend({
    urlRoot: '/delegate/civics-api/api/portal/favorites/cdr/instrumenttypes/',
    url: function() {
      if (this.instrumentType){
        if(this.id) {
          return this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()] + this.id;
        } else {
          return this.urlRoot + this.instrumentUrls[this.instrumentType.toLowerCase()];
        }
      }
      return this.urlRoot;
    },
    parse: function(r) {
      if(r.responseStatus) {
        this.responseStatus = r.responseStatus;
      }
      var rData = r.data ? r.data : r;
      var type = rData.type !=null ? rData.type.toLowerCase() : '';
      rData.idComplete = r.id + "|" + type;

      return rData;
    },
    idAttribute: 'idComplete',
    instrumentUrls: {
      building: 'Building/',
      businesslicense: 'BusinessLicense/',
      planning: 'Planning/',
      project: 'Project/',
      tradelicense: 'TradeLicense/',
      use: 'Use/',
    },
  });
})
